import { render, staticRenderFns } from "./yaklasikmaliyetgorevlileri.vue?vue&type=template&id=0654e0b5&"
import script from "./yaklasikmaliyetgorevlileri.vue?vue&type=script&lang=js&"
export * from "./yaklasikmaliyetgorevlileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports